import { render } from "./ForestryLandView.vue?vue&type=template&id=7fbddf46"
import script from "./ForestryLandView.vue?vue&type=script&lang=js"
export * from "./ForestryLandView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__